import { useEffect, useRef, useState } from "react";
import {
  CheckOutlined,
  CloseOutlined,
  CopyOutlined,
  DownloadOutlined,
  FormOutlined,
  RobotOutlined,
  SearchOutlined,
  SendOutlined,
  UserOutlined,
  WechatOutlined,
} from "@ant-design/icons";
import { Button, Empty, Input, message, Tag, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import apiClient from "../../actions/api";
import { updateBalance } from "../../actions/auth";
import isEmpty from "../../validations/is-empty";
import getDate from "../../untils/getDate";
import openNotification from "../../components/Notifications/openNotification";
import SupportChat from "./SupportChat";
import { getJobDomain, getJobFaviconUrl } from "../../untils/jobPlatform";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const ChatSection = (props) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const [open, setOpen] = useState(false);
  const [selectedChatId, setSelectedChatId] = useState("");
  const [selectedChatTitle, setSelectedChatTitle] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [searchText, setSearchText] = useState("");
  const [chatHis, setChatHis] = useState([
    {
      flag: true,
      content:
        "I apply for this position and please give me answer to this question in brief.",
    },
  ]);
  const [chatHistoryOpen, setChatHistoryOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [copiedMessageKey, setCopiedMessageKey] = useState(null);
  const chatHistoryRef = useRef(null);

  useEffect(() => {
    if (!isEmpty(user)) {
      handleGetRecentBids(user);
    }
  }, [user]);

  useEffect(() => {
    if (chatHistoryOpen && chatHistoryRef.current) {
      chatHistoryRef.current.scrollTo({
        top: chatHistoryRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [chatHis, chatHistoryOpen]);

  const handleOpenChatHistoryDialog = (id, cname) => {
    setChatHistoryOpen(true);
    setSelectedChatId(id);
    setSelectedChatTitle(cname);
    setChatHis([
      {
        flag: true,
        content:
          "I apply for this position and please give me answer to this question in brief.",
      },
    ]);
  };

  const handleChatHisClose = () => {
    setChatHistoryOpen(false);
    setSelectedChatTitle("");
    setSelectedChatId("");
    setChatHis([
      {
        flag: true,
        content:
          "I apply for this position and please give me answer to this question in brief.",
      },
    ]);
  };

  const handleToggleOpen = () => {
    const nextOpen = !open;
    setOpen(nextOpen);

    if (open) {
      setSearchText("");
      handleChatHisClose();
    }
  };

  const handleOpen = () => {
    const nextOpen = !open;
    setOpen(nextOpen);

    if (open) {
      setSearchText("");
      handleChatHisClose();
    }

    if (!open && !isEmpty(user)) {
      handleGetRecentBids(user);
    }
  };

  const handleSearchBidsByCompanyName = async (search_text) => {
    if (isEmpty(user)) {
      return;
    }

    const params = {
      user_id: user._id,
      search_text,
    };

    setLoading(true);

    await apiClient
      .post("/bids/get-bids-by-cname", params)
      .then((res) => {
        if (isEmpty(res.data?.result)) {
          setData([]);
          setLoading(false);
        } else {
          const tempData = res.data?.result.map((item, key) => {
            return {
              key: key + 1,
              id: item._id,
              created_at: getDate(item.date),
              company_name: item.company_name,
              salary_range: item.salary_range,
              job_desc: item.job_desc,
              pdf_url: item?.pdf_url,
              job_url: item.job_url,
              coverletter_filename: item?.coverletter_filename,
              coverletter_url: item?.coverletter_url,
              profile_name: item?.profile_name,
            };
          });

          setData(tempData);
          setLoading(false);
        }
      })
      .catch((err) => {
        if (!isEmpty(err?.response?.data?.errors)) {
          err.response.data.errors.forEach((item) => {
            openNotification("error", "Validation Error!", item.msg);
          });
        }
        setLoading(false);
      });
  };

  const handleGetRecentBids = async (user) => {
    const limit = 20;

    const params = {
      user_id: user._id,
      limit,
    };

    setLoading(true);

    await apiClient
      .post("/bids/get-recent", params)
      .then((res) => {
        if (isEmpty(res.data?.result)) {
          setData([]);
          setLoading(false);
        } else {
          const tempData = res.data?.result.map((item, key) => {
            return {
              key: key + 1,
              id: item._id,
              created_at: getDate(item.date),
              company_name: item.company_name,
              salary_range: item.salary_range,
              job_desc: item.job_desc,
              pdf_url: item?.pdf_url,
              job_url: item.job_url,
              coverletter_filename: item?.coverletter_filename,
              coverletter_url: item?.coverletter_url,
              profile_name: item?.profile_name,
            };
          });

          setData(tempData);
          setLoading(false);
        }
      })
      .catch((err) => {
        if (!isEmpty(err?.response?.data?.errors)) {
          err.response.data.errors.forEach((item) => {
            openNotification("error", "Validation Error!", item.msg);
          });
        }
        setLoading(false);
      });
  };

  const handleSendQuestion = async (text) => {
    const params = {
      id: selectedChatId,
      question: text,
      user_id: user._id,
    };

    setChatHis((prev) => [
      ...prev,
      {
        flag: true,
        content: text,
      },
    ]);

    await apiClient
      .post("/bids/get-answer", params)
      .then((res) => {
        if (!isEmpty(res.data?.result)) {
          dispatch(updateBalance(res.data.balance));
          setChatHis((prev) => [
            ...prev,
            {
              flag: false,
              content: res.data?.result,
            },
          ]);
        }
      })
      .catch((err) => {
        if (!isEmpty(err?.response?.data?.errors)) {
          err.response.data.errors.forEach((item) => {
            openNotification("error", "Validation Error!", item.msg);
          });
        }
        setLoading(false);
      });
  };

  const handleCopyAssistantMessage = async (content, key) => {
    try {
      await navigator.clipboard.writeText(content);
      setCopiedMessageKey(key);
      message.success("AI response copied");
      window.setTimeout(() => setCopiedMessageKey(null), 1800);
    } catch (err) {
      message.error("Could not copy the response");
    }
  };

  const handleDownloadCoverLetter = async (pdf_url, filename) => {
    const response = await fetch(`${API_BASE_URL}/job/description/${pdf_url}`, {
      method: "GET",
    });

    if (!response.ok) {
      return;
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };

  const handleGenerateCoverLetter = async (record) => {
    if (isEmpty(record?.profile_name) && isEmpty(user?.template_coverletter_url)) {
      openNotification(
        "error",
        "Validation Error!",
        "Please upload CoverLetter Template.",
      );
      return;
    }

    if (isEmpty(record?.pdf_url)) {
      openNotification(
        "error",
        "Validation Error!",
        "You can't generate CoverLetter without Resume.",
      );
      return;
    }

    const params = {
      user: user,
      bid: record,
    };

    setLoading(true);

    await apiClient
      .post("/bids/gen-coverletter", params)
      .then(async (res) => {
        if (res.data.status === "success") {
          dispatch(updateBalance(res.data.balance));
          const downloadPDFLink = res.data.downloadPDFLink;
          const coverletter_filename = res.data.coverletter_filename;

          setData((current) =>
            current.map((item) =>
              item.id === record.id
                ? {
                    ...item,
                    coverletter_url: downloadPDFLink,
                    coverletter_filename,
                  }
                : item,
            ),
          );

          await handleDownloadCoverLetter(
            downloadPDFLink,
            coverletter_filename,
          );

          message.success(res.data.msg);
        }

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        if (!isEmpty(err?.response?.data?.errors)) {
          err.response.data.errors.forEach((item) => {
            openNotification("error", "Validation Error!", item.msg);
          });
        }
      });
  };

  return (
    <div
      className={`preview-chat-section ${props.themeMode ? "chat-dark" : "chat-light"}`}
    >
      <div className="preview-chat-subsection">
        {chatHistoryOpen && (
          <div className="preview-chat-history-section">
            <div className="preview-chat-history-title">
              <div className="chat-title-icon">
                <RobotOutlined />
              </div>
              <div className="chat-title-copy">
                <strong>{selectedChatTitle}</strong>
                <span>AI application assistant</span>
              </div>
              <Button
                type="text"
                shape="circle"
                icon={<CloseOutlined />}
                onClick={handleChatHisClose}
                aria-label="Close conversation"
              />
            </div>
            <div className="preview-chat-history-main" ref={chatHistoryRef}>
              {!isEmpty(chatHis) &&
                chatHis.map((item, key) => {
                  const isSender = item.flag === true;
                  return (
                    <div
                      className={
                        isSender ? "chat-his-item-you" : "chat-his-item-gpt"
                      }
                      key={key}
                    >
                      {!isSender && (
                        <span className="application-message-avatar assistant">
                          <RobotOutlined />
                        </span>
                      )}
                      <div className="application-message-content">
                        <span className="application-message-author">
                          {isSender ? "You" : "AI assistant"}
                        </span>
                        <div className="chat-his-item">{item.content}</div>
                        {!isSender && (
                          <Tooltip
                            title={
                              copiedMessageKey === key
                                ? "Copied"
                                : "Copy full response"
                            }
                          >
                            <Button
                              type="text"
                              size="small"
                              className={`application-message-copy ${copiedMessageKey === key ? "copied" : ""}`}
                              icon={
                                copiedMessageKey === key ? (
                                  <CheckOutlined />
                                ) : (
                                  <CopyOutlined />
                                )
                              }
                              onClick={() =>
                                handleCopyAssistantMessage(item.content, key)
                              }
                            >
                              {copiedMessageKey === key
                                ? "Copied"
                                : "Copy response"}
                            </Button>
                          </Tooltip>
                        )}
                      </div>
                      {isSender && (
                        <span className="application-message-avatar sender">
                          <UserOutlined />
                        </span>
                      )}
                    </div>
                  );
                })}
            </div>
            <div className="preview-chat-input-section">
              <div className="preview-message-composer">
                <Input.TextArea
                  value={inputValue}
                  className="preview-chat-input"
                  placeholder="Ask about this application..."
                  autoSize={{ minRows: 1, maxRows: 4 }}
                  onChange={(e) => setInputValue(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                      e.preventDefault();
                      const value = e.target.value.trim();
                      if (!value) return;

                      handleSendQuestion(value);
                      setInputValue("");
                    }
                  }}
                />
                <Button
                  type="primary"
                  shape="circle"
                  className="preview-message-send"
                  icon={<SendOutlined />}
                  disabled={!inputValue.trim()}
                  aria-label="Send message"
                  onClick={() => {
                    const value = inputValue.trim();
                    if (!value) return;
                    handleSendQuestion(value);
                    setInputValue("");
                  }}
                />
              </div>
              <span className="preview-message-hint">
                Enter to send · Shift + Enter for a new line
              </span>
            </div>
          </div>
        )}
        {open && !loading && (
          <div className="preview-chat-main-section">
            <div className="preview-header">
              <div>
                <span className="preview-header-title">
                  Application assistant
                </span>
                <small>Select a recent bid to start a conversation</small>
              </div>
              <button
                type="button"
                className="preview-header-close-btn"
                onClick={() => handleToggleOpen()}
              >
                <CloseOutlined />
              </button>
            </div>
            <div className="preview-search-bar">
              <Input
                prefix={<SearchOutlined />}
                suffix={
                  <Button
                    type="primary"
                    size="small"
                    className="preview-search-submit"
                    icon={<SearchOutlined />}
                    disabled={!searchText.trim()}
                    onClick={() =>
                      handleSearchBidsByCompanyName(searchText.trim())
                    }
                  >
                    Search
                  </Button>
                }
                placeholder="Search companies..."
                value={searchText}
                className="preview-search-input"
                onChange={(e) => setSearchText(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    const value = e.target.value.trim();
                    if (!value) return;

                    handleSearchBidsByCompanyName(value);
                  }
                }}
              />
            </div>
            <div className="preview-table">
              {isEmpty(data) ? (
                <div className="preview-table-empty">
                  <Empty description="No Bids" />
                </div>
              ) : (
                <>
                  <div className="preview-table-head" aria-hidden="true">
                    <span>Source</span>
                    <span>Company</span>
                    <span>Profile</span>
                    <span>Salary</span>
                    <span>Date</span>
                    <span>Chat</span>
                    <span>Letter</span>
                  </div>
                  {data.map((item, key) => {
                    return (
                      <div
                        className={`preview-table-item ${item.id === selectedChatId ? "selected" : ""}`}
                        key={key}
                      >
                        <div className="table-item-img">
                          <Tooltip title={getJobDomain(item.job_url) || "Unknown Service"}>
                          <img
                            className="table-item-service-icon"
                            src={getJobFaviconUrl(item.job_url)}
                            alt="job service icon"
                          />
                          </Tooltip>
                        </div>
                        <Tooltip placement="top" title={item.company_name}>
                          <div
                            className="table-item-text company"
                            title={item.company_name}
                          >
                            {item.company_name}
                          </div>
                        </Tooltip>
                        <Tooltip title={item.profile_name || "Templates"}>
                          <div className="table-item-text profile">
                            <Tag
                              className={`application-profile-badge ${
                                item.profile_name
                                  ? "is-resume-profile"
                                  : "is-template-profile"
                              }`}
                            >
                              {item.profile_name || "Templates"}
                            </Tag>
                          </div>
                        </Tooltip>
                        <Tooltip
                          placement="top"
                          title={item.salary_range || "—"}
                        >
                          <div
                            className="table-item-text salary"
                            title={item.salary_range}
                          >
                            {item.salary_range || "—"}
                          </div>
                        </Tooltip>
                        <div
                          className="table-item-created-date"
                          title={item.created_at}
                        >
                          {item.created_at}
                        </div>
                        <div className="table-item-action">
                          <button
                            type="button"
                            className="table-item-chat-btn chat-action"
                            aria-label={`Chat about ${item.company_name}`}
                            onClick={() =>
                              handleOpenChatHistoryDialog(
                                item.id,
                                item.company_name,
                              )
                            }
                          >
                            <WechatOutlined />
                          </button>
                        </div>
                        <div className="table-item-action">
                          <Tooltip
                            placement="top"
                            title={
                              !isEmpty(item.coverletter_filename)
                                ? "Download PDF CoverLetter"
                                : "Generate CoverLetter"
                            }
                          >
                            {!isEmpty(item.coverletter_filename) ? (
                              <button
                                type="button"
                                className="table-item-chat-btn letter-action ready"
                                aria-label={`Download cover letter for ${item.company_name}`}
                                onClick={() =>
                                  handleDownloadCoverLetter(
                                    item.coverletter_url,
                                    item.coverletter_filename,
                                  )
                                }
                              >
                                <DownloadOutlined />
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="table-item-chat-btn letter-action"
                                aria-label={`Generate cover letter for ${item.company_name}`}
                                onClick={() => handleGenerateCoverLetter(item)}
                              >
                                <FormOutlined />
                              </button>
                            )}
                          </Tooltip>
                        </div>
                      </div>
                    );
                  })}
                </>
              )}
            </div>
          </div>
        )}
      </div>

      <div className="chat-launcher-stack">
        <SupportChat
          onOpenApplication={() => {
            if (open) handleOpen();
          }}
          applicationOpen={open}
        />
        <Tooltip title="Application assistant">
          <Button
            className={`chat-launcher app-launcher ${open ? "active" : ""}`}
            onClick={() => handleOpen()}
            type="primary"
            size="large"
            icon={open ? <CloseOutlined /> : <RobotOutlined />}
            loading={loading}
          />
        </Tooltip>
      </div>
    </div>
  );
};

export default ChatSection;
